import styles from "./FeeComponent.module.css";

import IconAndName from "../../components/IconAndName/IconAndName";

import { FaUserPlus, FaUpload } from "react-icons/fa";
import { useState } from "react";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { IoAddCircleOutline } from "react-icons/io5";
import CopyRight from "../../components/CopyRight/CopyRight";
import AllScheduledMovements from "../../sections/AllScheduledMovements/AllScheduledMovements";
import ProgramLevelMovements from "../../sections/ProgramLevelMovements/ProgramLevelMovements";
import FeeComponentSection from "../../sections/FeeComponentSection/FeeComponentSection";
import Discount from "../../sections/Discount/Discount";
import TaxRate from "../../sections/TaxRate/TaxRate";

const FeeComponent = () => {
  // default or make it dynamic later

  const handleFeeComponent = () => {
    dispatch(openModal("feeComponent"));
  };

  const handleAddDiscount = () => {
    dispatch(openModal("addDiscount"));
  };

  const handleTaxrate = () => {
    dispatch(openModal("addTaxrate"));
  };

  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("Fee Component");

  const tab = [
    {
      label: "Fee Component",
      content: <FeeComponentSection />,
    },
    {
      label: "Discount",
      content: <Discount />,
    },
    {
      label: "Tax rate",
      content: <TaxRate />,
    },
  ];

  return (
    <>
      <div className={styles.background}>
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {/* <TabSwitch tabs={tab} /> */}
              {tab.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`${styles.tabOptions} ${
                      activeTab === item.label && styles.ActivetabOption
                    }`}
                    onClick={() => setActiveTab(item.label)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
            {activeTab === "Fee Component" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Fee Component"
                  bgColor="Primary_Color"
                  onClick={handleFeeComponent}
                />
              </div>
            )}
            {activeTab === "Discount" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Discount"
                  bgColor="Primary_Color"
                  onClick={handleAddDiscount}
                />
              </div>
            )}
            {activeTab === "Tax rate" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Tax rate"
                  bgColor="Primary_Color"
                  onClick={handleTaxrate}
                />
              </div>
            )}
          </div>
          {tab.map((item) =>
            activeTab === item.label ? <>{item.content}</> : null
          )}
        </div>
      </div>
      <div>{<CopyRight />}</div>
    </>
  );
};

export default FeeComponent;
